import api from '../config/api';

const concentrationService = {
  async getAll() {
    const response = await api.get('/api/concentrations');
    return response.data;
  },
};

export default concentrationService;
